/**
 *
 * MobileLayout
 *
 */

import React, { memo, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import classNames from 'classnames';
import { Route, useLocation, withRouter } from 'react-router-dom';
// import queryString from 'query-string';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer from './reducer';
import saga from './saga';

// styles
import './style.scss';

import { flushState } from './actions';
import {
  makeSelectError,
  makeSelectLoading,
  makeSelectMobileLayout,
} from './selectors';

// antd component
import { Layout } from 'antd';
const { Content } = Layout;

// assets
//import CustomIcons from 'components/CustomIcons';

// test
import TestContainer from 'containers/TestContainer';

// layout components
import Preloader from 'components/Preloader';
import MobileHeaderLayout from 'layouts/MobileHeaderLayout';
import MobileBottomBar from 'layouts/MobileBottomBar';
// parent
import MobileParentHeader from 'layouts/MobileParentHeader';
import MobileTeacherHeader from 'layouts/MobileTeacherHeader';

// utils
import { appHelper } from 'appCapacitor/helpers';
import useDeviceDetect from 'utils/useDeviceDetect';
import AuthRoute from 'engine/AuthRoute';

// context
import {
  useLogout,
  useGetLocalUser
} from 'engine/Contexts/User.context';

// Mobile Pages
import AbsenceMobile from 'mobile/pages/AbsenceMobile';
import Home from 'mobile/pages/Home';
import CoursesMobile from 'mobile/pages/CoursesMobile';
import Attendance from 'mobile/pages/Attendance';
import CourseDetailMobile from 'mobile/pages/CourseDetailMobile';
// parent & teacher
import CommunicationsMobile from 'mobile/pages/CommunicationsMobile';
// parent
import CommunicationDetailMobile from 'mobile/pages/CommunicationDetailMobile';
import CommunicationNewMobile from 'mobile/pages/CommunicationNewMobile';
import SignupParent from 'mobile/pages/SignupParent';
// teacher
import TeacherCommunicationDetailMobile from 'mobile/pages/TeacherCommunicationDetailMobile';


export function MobileLayout({
  // actions here
  history,
  flushState,
   // default props
  className,
}) {
  useInjectReducer({ key: 'mobileLayout', reducer });
  useInjectSaga({ key: 'mobileLayout', saga });

  const location = useLocation();
  const { isMobile } = useDeviceDetect();

  const mobileMainRef = useRef();

  const currentPath = location.pathname.replace(/\//g, '');
  const defaultPath = currentPath ? currentPath : '';
 // const params = queryString.parse(history.location.search);

  let isApp = false;
  if (!appHelper.isWeb || isMobile) {
    isApp = true;
  }

  const logOut = useLogout();
  const localUser = useGetLocalUser()();

  const [activeMenu, setActiveMenu] = useState('/' + defaultPath);
  const [spinner, setSpinner] = useState(true);

  const [collapseHeader, setCollapseHeader] = useState(false);

  const [freshNotifications, setFreshNotifications] = useState([
    {
      _id: 1,
      title: 'Notif 1',
    },
  ]);

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */
  useEffect(() => {
    const preloader = setTimeout(() => setSpinner(false), 1500);
    
    // Anything in here is fired on component unmount.
    return () => {
      // this will clear setTimeout
      clearTimeout(preloader);
      setCollapseHeader(false);
      // Clearing the state after unmounting a component
      flushState();
    };
  }, []);

  // Log out from mobile version if user role is not 'teacher' or 'parent'
  useEffect(() => {
    if (isApp && localUser && localUser?.role == 'admin') {
      logOut();
    }
  }, [isApp]);


  const changeTabNavigation = route => {
    setActiveMenu(route);
    history.push(`${route}`);
  };

  const onBellClickHandler = () => {
    if (freshNotifications.length > 0) {
      //console.log({ freshNotifications });
    }
  };

  // Hide/Show Second Header for Parent/Teacher
  const handleMobileLayoutScroll = () => {
    const scrollTop = mobileMainRef?.current?.scrollTop;
    if (scrollTop <= 5) {
      setCollapseHeader(false);
    } else {
      setCollapseHeader(true);
    }
  };

  // render function
  return (
    <>
      {spinner && <Preloader fullWidth />}
      {!spinner && (
        <>
          <Layout className="app-main-layout app-main-layout--mobile">
            {/* Mobile Header/SideBar Menu */}
            <MobileHeaderLayout
              notifications={freshNotifications}
              notificationsAction={onBellClickHandler}
              //header={activeMenu !== 'home' && activeMenu}
            />

            <Content
              className={classNames(
                collapseHeader && 'collapsed-header',
                `layout-content mobile-layout-content`
              )}
              ref={mobileMainRef}
              onScroll={handleMobileLayoutScroll}
            >

              <MobileParentHeader
                roles={['parent']}
                visibility={true}
                collapse={collapseHeader}
              />

              <MobileTeacherHeader
                roles={['teacher']}
                visibility={true}
                collapse={collapseHeader}
              />

              {/* News */}
              <AuthRoute
                path={['/', '/home', '/communications']}
                component={CommunicationsMobile}
                roles={['parent', 'teacher']}
                exact
              />
              <AuthRoute path={'/communications/:ID'} component={CommunicationDetailMobile} roles={['parent']} exact />
              <AuthRoute path={'/communications/nouvel'} component={CommunicationNewMobile} roles={['parent']} exact />
              <AuthRoute path={'/communications/:ID'} component={TeacherCommunicationDetailMobile} roles={['teacher']} exact />

              {/* Mobile Pages */}
              <AuthRoute path={['/signupparent', '/linkstudent']} component={SignupParent} roles={['parent']} />

              <AuthRoute path="/absences" component={AbsenceMobile} roles={['parent', 'teacher']} exact />
              <AuthRoute path="/absences/:id" component={null} roles={['parent', 'teacher']} />
              <AuthRoute path="/attendance" component={Attendance} roles={['teacher']}  exact />
              <AuthRoute path={'/сours'} component={CoursesMobile} roles={['parent', 'teacher']} exact />
              <AuthRoute
                path={'/сours/:id'}
                component={CourseDetailMobile}
                roles={['teacher']}
                exact
              />
             
            </Content>
          </Layout>

          {/* Mobile Bottom Bar */}
          <MobileBottomBar
            selectedTab={activeMenu}
            changeTab={changeTabNavigation}
          />
        </>
      )}
    </>
  );
}

MobileLayout.propTypes = {
  dispatch: PropTypes.func.isRequired,
  flushState: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  loading: makeSelectLoading(),
  error: makeSelectError(),
  mobileLayout: makeSelectMobileLayout(),
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    flushState: () => dispatch(flushState()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
  withRouter
)(MobileLayout);
